import { Link } from "react-router-dom";

const tools = [
  { to: "/puns", title: "Pun Hits", blurb: "80s & 90s pun song machine.", color: "#ff2d78" },
  { to: "/limericks", title: "Limericks", blurb: "Five-line filth, family-edition coming soon.", color: "#00f5ff" },
];

export default function Landing() {
  return (
    <div style={{ minHeight: "calc(100vh - 60px)", background: "#08000f", color: "#fff", fontFamily: "Georgia, serif", padding: "48px 16px 60px" }}>
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <div style={{ fontSize: "11px", letterSpacing: "5px", color: "#00f5ff", marginBottom: "8px" }}>▶ COMEDY WRITER'S TOOLKIT</div>
        <div style={{ fontSize: "56px", fontFamily: "Impact, Arial Black, sans-serif", fontStyle: "italic", background: "linear-gradient(135deg, #ff2d78, #ffe600, #00f5ff)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", lineHeight: 1, textTransform: "uppercase" }}>PUNHITS</div>
        <div style={{ fontSize: "13px", color: "rgba(200,200,255,0.6)", marginTop: "12px" }}>Tools for ruining good songs and worse poems.</div>
      </div>

      <div style={{ maxWidth: "640px", margin: "0 auto", display: "grid", gap: "16px" }}>
        {tools.map(t => (
          <Link key={t.to} to={t.to} style={{ textDecoration: "none" }}>
            <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid " + t.color + "40", borderLeft: "4px solid " + t.color, borderRadius: "6px", padding: "20px" }}>
              <div style={{ fontSize: "22px", fontFamily: "Impact, sans-serif", fontStyle: "italic", color: t.color, textTransform: "uppercase", letterSpacing: "1px", marginBottom: "6px" }}>{t.title}</div>
              <div style={{ fontSize: "13px", color: "rgba(220,220,255,0.7)" }}>{t.blurb}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
